<template>
  <div :class="$style.container">
    <template v-if='activeShow'>
        <p :class="$style.title">{{ activeList.title }}</p>
        <div :class="$style.activeWrap">
            <img :class="$style.activeImg" :src="activeList.imgUrl" alt="">
            <div :class="$style.activeText">
                <div class="c-5 f-14">{{ activeList.linkUrl }}</div>
            </div>
        </div>
    </template>

    <p :class="$style.title">域名买越多，省更多!</p>
    <p :class="$style.title_desc">
      批量域名注册 、轻松搞定域名转入，众多后缀优惠供您选择！!
    </p>

    <div :class="$style.content">
      <template v-for="(item, index) in showList">
        <div :key="index" :class="$style.card">
          <div :class="$style.card_top">
            <div :class="$style.name">
              <span :class="$style.name_txt">{{ item.suffixName }}</span>
              <span
                :class="{
                  [$style.sign]: true,
                  [$style.sign_cu]: item.sign === '促',
                }"
                >热</span
              >
            </div>
            <div :class="$style.desc">{{ item.desc }}</div>
          </div>
          <div :class="$style.card_middle">
            <div :class="$style.txt">起价低至</div>
            <div :class="$style.price">
              <span :class="$style.price_number"
                >￥{{ item.suffixPriceList[3].price }}</span
              >
              /年
            </div>
          </div>
          <el-button @click="toDomainPrice">查看详情</el-button>
        </div>
      </template>
    </div>

    <p :class="$style.title">注意事项</p>
    <div>
      <div :class="$style.text">1、注册域名请先阅读：
          <AgreementPopup style="font-size:20px" :title="RulesTitle" :content="RulesContent" />
          <AgreementPopup :title="renewServiceTitle" :content="renewServiceContent" />
<!--          <AgreementPopup :title="templateServiceTitle" :content="templateServiceContent" />-->
      </div>
      <div :class="$style.text">2、CN域名注册后要经过CNNIC审核，如果审核不通过，则域名注册会被退回。</div>
    </div>
  </div>
</template>

<script>
import templateRules from "@/constant/templateRules";
import { getPriceList,getActivity } from "@server/index";
import { mapMutations } from "vuex";
import { getSensitiveWords,agreementList } from "@server";
import AgreementPopup from "@components/AgreementPopup.vue";
export default {
  name: "Hot",
  components:{
    AgreementPopup
  },
  data() {
    return {
      isLogin: true,
      showList: [], // 已选域名列表

      activeShow:true,
      activeList:{},

      RulesModelShow:false,
      RulesContent:'',
      RulesTitle:'',
      renewServiceModelShow: false,
      renewServiceContent: '',
      renewServiceTitle: '',

      templateServiceModelShow: false,
      templateServiceContent: '',
      templateServiceTitle: '',
    };
  },
  mounted() {
    this.getAgreementList()
    this.getSensitiveWordsList()
    this.getPriceList()
    this.getActivityList()

    this.templateServiceTitle = templateRules.title;
    this.templateServiceContent = templateRules.content;
  },
  methods: {
    ...mapMutations(['setSensitiveWords']),

    getAgreementList(){
      agreementList([1,2]).then((res) => {
              const { code, data } = res;
              if(code === 200 && data.length>0){
                this.RulesContent = data[0].content
                this.RulesTitle = data[0].name
                this.renewServiceContent = data[1].content
                this.renewServiceTitle = data[1].name
              }
      });
    },

    async getSensitiveWordsList(){
      const res = await getSensitiveWords()
      if(res.code === 200){
        this.setSensitiveWords(res.data)
      }
    },
    toDomainPrice() {
      this.$router.push("/dPrice");
    },
    async getPriceList() {
      const type = 0;
      const res = await getPriceList(type);
      const { code, message, data } = res;

      if (code === 200) {
        this.showList = data;
      } else {
        this.$message({ message });
      }
    },
    async getActivityList(){
      const { code, data } = await getActivity()
      if (code == 200) {
        if(data.bannerList.length>0){
           this.activeShow = true
           this.activeList = data.bannerList[0]
        }else{
          this.activeShow = false
        }
      }
    }
  }
};
</script>

<style lang="scss" module scoped>
.container {
  box-sizing: border-box;
  width: rem(1200);
  margin: rem(60) auto;
  border-radius: 5px;
  .activeWrap{
     width: 1200px;
     margin-bottom: 50px;
    .activeText{
     margin-top: 20px;
     line-height: 30px;
     color: #666;
     text-indent: 2em;
   }
    .activeImg{
      width: 1200px;
    }
  }
  .title {
    font-size: rem(30);
    font-weight: bold;
    color: #333;
    line-height: rem(70);
  }
  .text{
     font-size: rem(14);
     color: #333;
     line-height: rem(32);
  }

  .title_desc {
    font-size: 14px;
    color: #666;
    line-height: 14px;
    margin-bottom: 35px;
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .card {
    box-sizing: border-box;
    width: rem(260);
    height: rem(300);
    margin-right: rem(50);
    margin-bottom: rem(40);
    padding: rem(20) rem(40);
    background: #fff;
    border: 1px solid transparent;
    border-radius: 4px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &:hover {
      border-color: $theme-color;
      box-shadow: 0px 7px 30px 0px rgba(211, 214, 221, 0.7);
    }
  }

  .card_top {
    height: rem(120);
    overflow: hidden;

    .name {
      height: rem(48);
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      overflow: hidden;

      .name_txt {
        display: inline-block;
        margin: 0 rem(15) rem(6) rem(6);
        font-size: rem(30);
        font-family: Microsoft YaHei;
        color: #000;
      }

      .sign {
        display: inline-block;
        width: rem(18);
        height: rem(18);
        font-size: 12px;
        color: #fff;
        text-align: center;
        line-height: rem(18);
        background: $theme-color;
        &.sign_cu {
          background: #f8ba3f;
        }
      }
    }

    .desc {
      font-size: rem(14);
      color: #999;
      line-height: rem(24);
    }
  }

  .card_middle {
    margin-bottom: rem(15);
    .txt {
      font-size: 12px;
      color: #333;
      line-height: 12px;
    }

    .price {
      padding: rem(15) 0;
      font-size: rem(18);
      color: #333333;

      .price_number {
        font-size: rem(24);
        font-family: DINSchrift;
        font-weight: 600;
      }
    }
  }

  :global {
    ::v-deep .el-button {
      width: rem(90);
      height: rem(40);
      padding: rem($padding-3n) 0;
      text-align: center;
      border-radius: rem(4);
      @include flex();

      & > span {
        height: 12px;
        font-size: 12px;
        color: #999;
      }

      &:hover {
        border-color: $theme-color;
        background-color: $theme-color;
        & > span {
          color: #fff;
        }
      }
    }
  }
}
</style>

